import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Ambient full-bleed video that sits behind a page's header, drifts and
// zooms gently as you scroll (parallax), then dissolves into the page.
export const VideoBackdrop = ({ src, height = "h-[92vh]", testid = "video-backdrop" }) => {
  const ref = useRef(null);
  const [ok, setOk] = useState(true);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "26%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.03, 1.16]);
  const opacity = useTransform(scrollYProgress, [0, 0.85, 1], [1, 0.9, 0]);

  if (!src) return null;

  return (
    <div ref={ref} aria-hidden="true" className={`absolute inset-x-0 top-0 -z-10 ${height} overflow-hidden`}>
      {!ok ? (
        // graceful fallback if the film can't play: a quiet champagne wash
        <div className="h-full w-full bg-gradient-to-br from-[#F3E5AB]/50 via-[#FAF8F5] to-[#F5EBE6]" />
      ) : (
        <motion.video
          style={{ y, scale, opacity }}
          className="h-full w-full object-cover will-change-transform"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onError={() => setOk(false)}
          data-testid={testid}
        >
          <source src={src} type={src.includes(".webm") ? "video/webm" : "video/mp4"} onError={() => setOk(false)} />
        </motion.video>
      )}
      {/* legibility wash + dissolve into page background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAF8F5]/80 via-[#FAF8F5]/45 to-[#FAF8F5]" />
      <div className="absolute inset-0 bg-[#F3E5AB]/10 mix-blend-multiply" />
    </div>
  );
};
